import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchiveFaded = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 0) scale(1.5)",
		children: [/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M14.6667 12.6666V10.6666C14.6667 9.56206 13.7712 8.66663 12.6667 8.66663H12C11.5803 8.66663 11.1852 8.86422 10.9333 9.19996L10.1333 10.2666C9.62973 10.9381 8.83936 11.3333 8.00001 11.3333C7.16066 11.3333 6.37029 10.9381 5.86668 10.2666L5.06668 9.19996C4.81487 8.86422 4.41969 8.66663 4.00001 8.66663H3.33334C2.22877 8.66663 1.33334 9.56206 1.33334 10.6666V12.6666C1.33334 13.7712 2.22877 14.6666 3.33334 14.6666H12.6667C13.7712 14.6666 14.6667 13.7712 14.6667 12.6666Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.33332 8.66671H3.99999C4.41967 8.66671 4.81485 8.8643 5.06666 9.20004L5.86666 10.2667C6.37027 10.9382 7.16064 11.3334 7.99999 11.3334C8.83934 11.3334 9.62971 10.9382 10.1333 10.2667L10.9333 9.20004C11.1851 8.8643 11.5803 8.66671 12 8.66671H12.6667C12.9004 8.66671 13.1248 8.70681 13.3333 8.78051V4.00004C13.3333 2.52728 12.1394 1.33337 10.6667 1.33337H5.33332C3.86056 1.33337 2.66666 2.52728 2.66666 4.00004V8.78051C2.87518 8.70681 3.09957 8.66671 3.33332 8.66671ZM9.99999 6.50004C10.2761 6.50004 10.5 6.27618 10.5 6.00004C10.5 5.7239 10.2761 5.50004 9.99999 5.50004H5.99999C5.72385 5.50004 5.49999 5.7239 5.49999 6.00004C5.49999 6.27618 5.72385 6.50004 5.99999 6.50004H9.99999Z",
			fill: "currentColor"
		})]
	})]
});
const ForwardRef = forwardRef(SvgArchiveFaded);
export default ForwardRef;
